import React, { useState } from "react";
import copy from "clipboard-copy";
import submit from "submit-form";
import PlansTable from "./components/PlansTable.js";
import { getUserToRequest } from "../../dashboard/settings/manage-coaches/utils/manage-coaches-utils";
import SvgIcon from "../../../parts/SvgIcon.js";
const tabs = {
  PULL: "pull",
  PUSH: "push",
  PRESS: "press",
};
const PlanManager = (props, { locals }) => {
  const { activeUser, planManager, organizationOwner } = locals;

  const userToRequest = getUserToRequest(activeUser, organizationOwner);
  const { pressAccountInfo, pushAccountInfo, pressCustomBranding } =
    userToRequest;
  const { pressPlans, pushPlans } = planManager;
  const isPressCoach = !!pressAccountInfo;
  const isPushCoach = !!pushAccountInfo;
  const [selectedTab, setSelectedTab] = useState(tabs.PUSH);

  const getPaymentLink = async (e, planId, domain = "gymmembership.app") => {
    e.preventDefault();
    const { subdomain } = pushAccountInfo;
    const url = `https://${subdomain}.${domain}/checkout/${planId}`;
    await copy(url);
    submit("/actions/refresh", {
      method: "GET",
      body: {
        copied: true,
      },
    });
  };

  const updatePlanStatus = (id, status) => {
    submit(`/actions/plan-manager/status`, {
      method: "POST",
      body: { status: !status ? "unpublish" : "publish", id },
    });
  };

  const preferPlan = (e, id, preferred = "false", plans) => {
    e.preventDefault();
    submit(`/actions/plan-manager/preferred`, {
      method: "POST",
      body: { id, preferred, plans },
    });
  };

  return (
    <main className="plan-manager">
      <header>
        <nav role="tablist">
          {isPushCoach && (
            <a
              aria-current={selectedTab === tabs.PUSH ? true : undefined}
              href="#"
              onClick={(e) => {
                e.preventDefault();
                setSelectedTab(tabs.PUSH);
              }}
            >
              Subscription Plans (PUSH)
            </a>
          )}
          {isPressCoach && (
            <a
              aria-current={selectedTab === tabs.PRESS ? true : undefined}
              href="#"
              onClick={(e) => {
                e.preventDefault();
                setSelectedTab(tabs.PRESS);
              }}
            >
              Gym Membership Plans (PRESS)
            </a>
          )}
          <hgroup>
            {isPressCoach && selectedTab === tabs.PRESS && props.csvPress && (
              <a
                role="button"
                data-button-type="outline"
                target="_blank"
                href={`data:attachment/csv,${encodeURIComponent(
                  props.csvPress
                )}`}
                download="plans.csv"
                sz="small"
              >
                <span>Export to csv</span>
              </a>
            )}
            {isPressCoach && selectedTab === tabs.PRESS && (
              <a
                role="button"
                data-button-type="secondary"
                className="manage"
                href="/coaching-portal/settings/gym-locations"
                sz="small"
              >
                Manage Gym Locations
              </a>
            )}
            {selectedTab === tabs.PUSH && (
              <a
                role="button"
                data-button-type="secondary"
                href={`/actions/refresh?modal[type]=create-coupon`}
                sz="small"
                data-icon
                className="create-coupon"
              >
                <SvgIcon src="/img/new-icons/ticket.svg" />
                Create coupon
              </a>
            )}
            {(isPressCoach || isPushCoach) && selectedTab && (
              <a
                role="button"
                data-button-type="primary"
                href={`/actions/refresh?modal[type]=create-plan&type=${selectedTab}`}
                sz="small"
                data-icon
              >
                <img src="/img/new-icons/add.svg" alt="add icon" />
                Add New
              </a>
            )}
          </hgroup>
        </nav>
      </header>
      {isPressCoach && selectedTab === tabs.PRESS && (
        <PlansTable
          title="Gym Membership Plans (PRESS)"
          isPress
          plans={pressPlans}
          getPaymentLink={getPaymentLink}
          updatePlanStatus={updatePlanStatus}
          preferPlan={preferPlan}
          gymLocations={pressCustomBranding?.gymLocations}
          csv={props.csvPress}
        />
      )}

      {isPushCoach && selectedTab === tabs.PUSH && (
        <PlansTable
          title="Subscription Plans (PUSH)"
          plans={pushPlans}
          getPaymentLink={getPaymentLink}
          updatePlanStatus={updatePlanStatus}
          preferPlan={preferPlan}
          planType="push"
        />
      )}
    </main>
  );
};

export default PlanManager;
